import styled from 'styled-components';
import { BLACK } from 'root/theme';
import media from '../../oldpantheon/utils/media';

export const CompatibilityHeader = styled.h2`
  font-family: Calistoga;
  font-size: 1.5rem;
  margin: 0 auto;
  text-align: center;
  display: block;
  color: ${BLACK};
  ${media.extraSmall`
    text-align: center;
    margin: 0rem;
  `}
`;

export const MobileButton = styled.div`
  display: block;
  a {
    text-decoration: none;
  }
  ${media.extraSmall`
    display: block;
  `}
`;

export const CompatibilityImage = styled.img`
  width: 130px;
  height: auto;
  margin-right: 1rem;
  display: flex;
  ${media.small`
    margin: 0 auto;
  `} 
`;

export const CompatibilityText = styled.p`
  text-align: left;
  color: ${BLACK};
  ${media.small`
    text-align: center;
  `} 
`;

export const CompatibilityWrapper = styled.div`
  display: flex;
  flex-direction: row;
  ${media.small`
    flex-direction: column;
  `} 
`;
